import "./infoEntry.component.scss";

interface IComponentBindings {
    title: string;
    entries: { name: string, value: string }[];
}

export class InfoEntryComponentController implements angular.IComponentController, IComponentBindings {

    // bindings
    title: string;
    entries: { name: string, value: string }[];

    static $inject = [];

    constructor() {}

    $onInit() { }

}

export class InfoEntryComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: { [slot: string]: string };

    constructor() {
        this.bindings = {
            title: "@",
            entries: "<?"
        };

        this.transclude = {
            "commissionCheck": "?foundationCommissionCheck"
        }

        this.controller = InfoEntryComponentController;
        this.template = require("./infoEntry.component.html");
    }
}
